import useGet from "../Hooks/useGet";
import API_ENDPOINTS from "../Config/api";
import SecurityTabs from "../Components/SecurityTabs";
import Nis2Risk from "../Components/Nis2Risk";
import AwarenessCard from "../Components/AwarenessCard";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from 'react-i18next';

export default function Report({ id = '' }) {
  const { t } = useTranslation();

  const { fetchedData: risposte } = useGet(API_ENDPOINTS.questionarioRisposte(id));
  const { fetchedData: nis2Report } = useGet(API_ENDPOINTS.nis2Report(id));
  const { fetchedData: cyberlogTesti } = useGet(API_ENDPOINTS.cyberlogTesti);

  // Check if nis2Report has an error (questionario not completed)
  const hasNis2Error = nis2Report && nis2Report.error;
  const validNis2Report = nis2Report && !nis2Report.error ? nis2Report : null;

  if (!risposte && !nis2Report && !cyberlogTesti) return (
    <div className="flex justify-center flex-1">
      <ClipLoader />
    </div>
  )

  return (
    <div className="flex flex-col">

      <div className="mx-auto p-4 max-w-7xl">

        <div>
          {validNis2Report ? <AwarenessCard percentage={validNis2Report?.indice_consapevolezza} /> : null}
        </div>

        <div className="flex justify-center mt-5 bg-white p-7 rounded-md border">
          {validNis2Report ? (
            <Nis2Risk nis2ReportData={validNis2Report} isVisibleDescriptionBanner={false} isVisibleDownloadReport={false} />
          ) : hasNis2Error ? (
            <div className="text-center py-8">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">{t('report.nis2UnavailableTitle')}</h3>
              <p className="text-gray-600">{nis2Report.error}</p>
              <p className="text-sm text-gray-500 mt-2">{t('report.completeQuestionnaire')}</p>
            </div>
          ) : (
            <div className="text-center py-8">
              <h3 className="text-lg font-semibold text-gray-700">{t('report.loadingReport')}</h3>
            </div>
          )}
        </div>

        <div className="mt-10">
          {cyberlogTesti && validNis2Report ?
            <SecurityTabs risposte={risposte} visibleQuestions={true} />
            : null}
        </div>

      </div>
    </div>

  );
}


